import { DateTime } from "luxon";
import { create } from "zustand";

type TableDateState = {
    date: DateTime;
};
type TableDateActions = {
    actions: {
        setDate: (date: DateTime) => void;
    };
};

export const useTableDateStore = create<TableDateState & TableDateActions>()((set) => ({
    date: DateTime.now().plus({ days: 1 }), // todo:
    actions: {
        setDate: (date) => set({ date }),
    },
}));

export const useTableDate = () => useTableDateStore((state) => state.date);
export const useTableDateActions = () => useTableDateStore((state) => state.actions);
